function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#F6FAFF",
  fillRule: "evenodd",
  d: "M0 0v22.91h75.602V184H103V0H0zm0 29v22.586h42.436V184H69V29H0z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 103,
    height: 184,
    viewBox: "0 0 103 184"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/number2.87ff5f45.svg";
export { SvgComponent as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ./node_modules/svgr/webpack.js!./src/containers/static/landing/number2.svg
// module id = 388
// module chunks = 0